<template>
  <div class="login-container">
    <div class="login-view__header">
      <img class="login-view__brand" src="@/assets/reflective-learning-logo/rl-small-icon-white.png" alt="Icon" />
      <button class="login-view__alt-login-btn" @click="goToStudent">
        Student Login
      </button>
    </div>

    <div class="login-fields">
      <form>
        <div v-if="!resetPasswordFlag && !messageSent" class="logo">
          <h1 class="header-2 has-text-centered" style="margin-bottom: 1.5rem">
            Dashboard Login
          </h1>
        </div>
        <div class="login-inputs" v-if="!resetPasswordFlag && !messageSent">
          <div>
            <validation-observer ref="email">
              <validation-provider rules="required|email" name="Email">
                <b-field :message="errors" slot-scope="{ errors, valid }"
                  :type="{ 'is-danger': errors[0], 'is-success': valid }"
                  :custom-class="email.length > 0 ? 'is-focus' : 'is-focus'">
                  <b-input v-model="email" placeholder="Email" type="email" :class="email.length < 1 ? 'border' : ''"
                    id="Email"></b-input>
                </b-field>
              </validation-provider>
            </validation-observer>
          </div>
          <validation-observer ref="password">
            <validation-provider rules="required|password" name="Password">
              <b-field label-position="inside" :message="errors" slot-scope="{ errors, valid }"
                v-on:keyup.native.enter="handleClick" :type="{ 'is-danger': errors[0], 'is-success': valid }"
                :custom-class="password.length > 0 ? 'is-focus' : 'is-focus'">
                <b-input v-model="password" placeholder="Password" :class="email.length < 1 ? 'border' : 'border'"
                  password-reveal type="password" id="Password"></b-input>
              </b-field>
            </validation-provider>
          </validation-observer>
          <a class="forgot-password-link" @click="resetPasswordFlag = true">Forgot Password?</a>
        </div>

        <div class="login-inputs" v-if="resetPasswordFlag">
          <div class="component-header" style="text-align: center; font-size: 1.8em; margin-bottom: 0.7em">
            Recover Password
          </div>
          <div>
            <validation-observer ref="reset">
              <validation-provider rules="required|email" name="Email">
                <b-field :message="errors" slot-scope="{ errors, valid }" v-on:keyup.native.enter="resetPassword"
                  :type="{ 'is-danger': errors[0], 'is-success': valid }"
                  :custom-class="email.length > 0 ? 'is-focus' : 'is-focus'">
                  <b-input v-model="email" placeholder="Enter your email" type="email"
                    :class="email.length < 1 ? 'border' : ''" id="reset"></b-input>
                </b-field>
              </validation-provider>
            </validation-observer>
          </div>
        </div>
      </form>
      <b-button v-if="!resetPasswordFlag && !messageSent" class="button login-button"
        @click="handleClick">Login</b-button>
      <b-button v-if="resetPasswordFlag" class="button login-button" @click="resetPassword">Email me a recovery
        link</b-button>
      <b-button v-if="resetPasswordFlag" class="button return-button" style="border: 1px solid #777"
        @click="resetPasswordFlag = false">Return to login</b-button>
      <div v-if="messageSent" @click="resetPage" class="rb" style="padding: 2rem; border: 1px solid #90bf3e">
        <div class="semibold mb" style="text-align: center">
          A reset link has been sent to your email. Thank you!
        </div>
        <div style="text-align: center">
          <b-button class="button login-button" style="padding: 1rem 2rem 1rem">Ok</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import authservice from "@/modules/auth/services/auth-services.js";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  name: "Login",
  data() {
    return {
      email: "",
      password: "",
      resetPasswordFlag: false,
      messageSent: false,
    };
  },
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  computed: {
    ...mapState({
      user: "user",
      isProject: (state) => state.globalStore.settings.isProject,
      schools: (state) => state.globalStore.filterLists.schools,
    }),
    ...mapGetters({
      isInternal: "globalStore/isInternal",
    }),
  },
  async mounted() {
    // get uid url parameter
    if (this.$route.query.uid && this.$route.query.pw) {
      let getNewJWT = await this.fetchMyDetails(this.$route.query.uid);

      if (getNewJWT) {
        if (this.isInternal) {
          await this.loading(false);
          this.$router.push({ name: "home" });
        } else {
          await this.loading(false);
          this.$router.push({ name: "home" });
        }
      }
    }
  },
  methods: {
    ...mapActions({
      fetchMyDetails: "loginStore/fetchMyDetails",
      fetchMyLearners: "globalStore/fetchMyLearners",
      loading: "SET_SCREEN_LOADING",
    }),
    async handleClick() {
      await this.loading(true);
      this.$refs.email.validate().then(async (success) => {
        if (!success) {
          await this.loading(false);
          return this.onError("Invalid Email");
        }
        this.$refs.password.validate().then(async (success) => {
          if (!success) {
            await this.loading(false);
            return this.onError("Invalid Password");
          }
          try {
            this.login();
          } finally {
            // eslint-disable-next-line no-console
          }
        });
      });
    },
    login() {
      authservice.methods
        .emailPasswordLogin(this.email, this.password)
        .then(async (res) => {
          let uid = res.user.uid;
          let getNewJWT = await this.fetchMyDetails(uid);

          if (getNewJWT) {
            if (this.isInternal) {
              await this.loading(false);
              this.$router.push({ name: "home" });
            } else {
              await this.loading(false);
              this.$router.push({ name: "home" });
            }
          }
        })
        .catch((loginError) => {
          this.loading(false);
          switch (loginError.code) {
            case "auth/user-not-found":
              this.onError("Account Not Found");
              break;

            case "auth/wrong-password":
              this.onError("Invalid password");
              break;

            default:
              break;
          }
        });
    },
    goToStudent() {
      window.location.href = "https://app.reflectivelearning.co.za/auth/login";
    },
    resetPassword() {
      this.$refs.reset.validate().then(async (success) => {
        if (!success) {
          return this.onError("Invalid Email");
        }
        authservice.methods
          .sendPasswordResetEmail(this.email)
          .then(() => {
            this.resetPasswordFlag = false;
            this.messageSent = true;
          })
          .catch((resetError) => {
            switch (resetError.code) {
              case "auth/user-not-found":
                this.onError("Account Not Found");
                break;

              default:
                break;
            }
          });
      });
    },
    resetPage() {
      this.messageSent = false;
      this.resetPasswordFlag = false;
    },
    onError(errorMessage) {
      this.$buefy.snackbar.open({
        message: errorMessage,
        queue: false,
        type: "is-danger",
      });
    },
  },
};
</script>
